import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_263: DocMigration = {
  maxSchemaVersion: "0.0.263",
  description: "Null out any field that has 'JsonNull' in it",
  apply(json: any) {
    function jsonNullToNull(obj: any): any {
      for (const key in obj) {
        if (obj[key] === "JsonNull") {
          obj[key] = null;
        } else if (typeof obj[key] === `object` && !Array.isArray(obj[key])) {
          obj[key] = jsonNullToNull(obj[key]);
        }
      }
      return obj;
    }
    jsonNullToNull(json);
    return json;
  },
};

export default migration_0_0_263;
